/* acaciasupplies — motion.js (S39). Lo que motion.css no puede decidir solo
   y que puede esperar al DOM. Diferido. Lo que tiene que estar antes del
   primer pintado —las clases mo, mo-enter y mo-draw en <html>, la vez por
   sesión del logotipo y el salto en las transiciones de vista— vive en
   `snippets/motion-boot.liquid`. Entre los dos, ≤ 4 kB y sin dependencias. */
(function () {
  'use strict';

  var root = document.documentElement;

  /* Sin `mo`, motion-boot decidió que no hay movimiento (reduced-motion). */
  if (!root.classList.contains('mo')) return;

  /* Primer pintado: lo que empieza por debajo del pliegue no se anima. Y lo
     que ya terminó se suelta de la animación, para que un `transform`
     rellenado no se quede haciendo de bloque contenedor. */
  function settleSections() {
    var fold = window.innerHeight || root.clientHeight;
    var sections = document.querySelectorAll('#main > .shopify-section');
    for (var i = 0; i < sections.length && i < 5; i++) {
      if (sections[i].getBoundingClientRect().top >= fold) sections[i].setAttribute('data-mo-still', '');
    }
    document.addEventListener('animationend', function (event) {
      if (event.animationName === 'mo-enter') event.target.setAttribute('data-mo-still', '');
    });
  }

  /* Línea de ruta: se traza una vez al entrar en pantalla. Sin
     IntersectionObserver se da por trazada y se ve entera. */
  function initRoutes() {
    var routes = document.querySelectorAll('.supply-route');
    if (!routes.length) return;

    Array.prototype.forEach.call(routes, function (route) {
      var stops = route.querySelectorAll('.supply-route__stop');
      for (var i = 0; i < stops.length; i++) stops[i].style.setProperty('--mo-i', i);
    });

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(routes, function (route) { route.classList.add('is-drawn'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-drawn');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.5 });

    Array.prototype.forEach.call(routes, function (route) { observer.observe(route); });
  }

  function ready() {
    settleSections();
    initRoutes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
